import { Chip } from "@mui/material";
import { ObjectValues } from "../login";

import {
  School as SchoolIcon,
  Flag as FlagIcon,
  Category as CategoryIcon,
  MenuBook as MenuBookIcon,
  LocalLibrary as LocalLibraryIcon,
  LabelImportant as LabelImportantIcon,
  Layers as LayersIcon,
  Quiz as QuizIcon,
  Delete,
} from "@mui/icons-material";
import { fuzzySearch } from "../../Components/CustomSearch";
import { MockLevelTypes } from "../../store/slices/detailedMaster/detailedMasterSlice";

export const chipConfigs = (data: any) =>
  [
    (data.total_mocktests || data.total_mocktests === 0) && {
      key: "mocks",
      label: "Mock Tests",
      value: data.total_mocktests,
      color: "#eff6ff",
      text: "#2563eb",
    },
    (data.total_sections || data.total_sections === 0) && {
      key: "section",
      label: "Sections",
      value: data.total_sections,
      color: "#f0fdf4",
      text: "#16a34a",
    },

    data.total_questions && {
      key: "question",
      label: "Questions",
      value: data.total_questions,
      color: "#eef2ff",
      text: "#4f46e5",
    },
  ].filter((s) => s);
export const getNextPath = (type: MockLevelTypes): MockLevelTypes => {
  switch (type) {
    case "series":
      return "mocktest";
    case "mocktest":
      return "section";
    case "section":
      return "question";
    default:
      return "series";
  }
};

export const getParentPath = (type: MockLevelTypes) => {
  switch (type) {
    case "mocktest":
      return "series";
    case "section":
      return "mocktest";
    case "question":
      return "section";
    default:
      return "series";
  }
};
export type Node = {
  id: string;
  label: string;
  type: MockLevelTypes;
  status?: "Draft" | "Published";
  children?: Node[];
  details: ObjectValues;
};

// ---------- Helpers / sample data ----------
export const ICON_BY_TYPE: any = {
  series: <SchoolIcon fontSize="small" />,
  mocktest: <FlagIcon fontSize="small" />,
  section: <CategoryIcon fontSize="small" />,
  quesion: <QuizIcon fontSize="small" />,
};
export const colors: any = {
  series: "#e5e7eb",
  mocktest: "#2563eb",
  section: "#16a34a",
  quesion: "#4f46e5",
};
export const bgcolors: any = {
  series: "white",
  mocktest: "#eff6ff",
  section: "#f0fdf4",
  quesion: "#4f46e5",
};

// ---------- Small UI pieces ----------
export function TypeChip({ type }: { type: MockLevelTypes }) {
  return (
    <Chip
      size="small"
      label={`${type}s`}
      icon={ICON_BY_TYPE[type]}
      sx={{
        textTransform: "uppercase",
        fontWeight: 700,
        height: 24,
        padding: "0 7px",
        "& .MuiChip-label": { px: 0.5 },
        "& .MuiSvgIcon-root": { margin: "0 !important" },
      }}
    />
  );
}
export const serachFilterFunction = (list: ObjectValues[], search: any) => {
  const fieldName = ["label"];
  const filterData: ObjectValues[] = [];
  if (list && fieldName && search) {
    list.map((data: ObjectValues) => {
      return fieldName.map((singleField) => {
        if (
          (data[singleField] &&
            data[singleField]
              .toString()
              .toLowerCase()
              .includes(search.toString().toLowerCase())) ||
          fuzzySearch(search.toString().toLowerCase(), data[singleField])
        ) {
          if (!filterData.includes(data)) {
            return filterData.push(data);
          } else {
            return null;
          }
        } else {
          return null;
        }
      });
    });
    return filterData;
  } else {
    return list;
  }
};
export const formatNestedList = (lists: any[], level: any) => {
  return lists.map((s) => {
    return {
      id: s.id,
      label:
        level === "series"
          ? `${s.exam_name} - ${s.goal__name} - ${s.name}`
          : s.name ?? `#${s.id}`,
      type: level,
      status: s.status,
      details: s,
      children:
        level === "series"
          ? s.total_mocktests > 0
            ? []
            : undefined
          : level === "mocktest"
          ? s.total_sections > 0
            ? []
            : undefined
          : level === "section"
          ? s.total_questions > 0
            ? []
            : undefined
          : [],
    };
  });
};
export interface Translation {
  id: number;
  status: string;
  parent_id: number;
  text: string;
  language: string;
  media_urls: string[] | null;
  description: string | null;
  is_active: boolean;
  created_at: string;
  modified_at: string;
  parent_model: number;
  created_by: number;
  modified_by: number;
}

export interface Explanation {
  id: number;
  translation: Translation[];
  status: string;
  parent_id: number;
  default_language: string;
  source: string;
  quality_score: number | null;
  prompt_used: string | null;
  prompt_count: number | null;
  is_active: boolean;
  created_at: string;
  modified_at: string;
  parent_model: number;
  created_by: number;
  modified_by: number;
}

export interface Option {
  id: number;
  translation: Translation[];
  status: string;
  order: number;
  is_correct: boolean;
  is_active: boolean;
  default_language: string;
  created_at: string;
  modified_at: string;
  old_id: number | null;
  question: number;
  created_by: number;
  modified_by: number;
}

export interface Question {
  id: number;
  translation: Translation[];
  explanation: Explanation;
  options: Option[];
  tag: any[]; // replace `any[]` with a proper Tag interface if you have it
  status: string;
  default_language: string;
  can_be_ready: boolean;
  can_be_approved: boolean;
  v2_to_v3: any | null;
  mockqc_status: any | null;
  is_active: boolean;
  created_at: string;
  modified_at: string;
  old_id: number | null;
  is_proofread_hi: boolean;
  question_type: string | null;
  cluster: number;
  created_by: number;
  modified_by: number;
}
